import { useState, useEffect } from "react";
import InputFilter from "../../components/GInput/InputFilter";
import DropDownFilterSearch from "../../components/GDropDownList/DropDownFilterSearch";
import DropDownFilter from "../../components/GDropDownList/DropDownFilter";
import { motion, AnimatePresence } from "framer-motion";
import StateCard from "../sharedUi/stateCard";
import { FaArrowUp } from "react-icons/fa";
import { FaArrowDown } from "react-icons/fa";
import { MdPriceCheck } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FaAdversal } from "react-icons/fa";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

export default function AdsFilter ({categoriesParentData, categoriesChildData, values, typeOfUsers, typeOfcurrency, typeOfAds, searchCategoryParent, searchCategoryChild}) {

    const [value, setValue] = useState({});
    const statisticsData = useSelector((state) => state.statistics.items);
    const [visible, setVisible] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    const handleVisible = () => {
        setVisible(!visible);
    }

    useEffect(() => {

        const updatedValue = values.reduce((acc, item) => ({
            category_id: item.category_id || acc.category_id || "",
            sub_category_id: item.sub_category_id || acc.sub_category_id || "",
            minPrice: item.minPrice || acc.minPrice || "",
            maxPrice: item.maxPrice || acc.maxPrice || "",
            typePublisher: item.typePublisher || acc.typePublisher || "",
            from_date: item.from_date || acc.from_date || "",
            to_date: item.to_date || acc.to_date || "",
            orderStatus: item.orderStatus || acc.orderStatus || "",
            currency: item.currency || acc.currency || "",
            id: item.id || acc.id || "",
        }), {
            category_id: "",
            sub_category_id: "",
            minPrice: "",
            maxPrice: "",
            typePublisher: "",
            from_date: "",
            to_date: "",
            id: "",
            currency: "",
            orderStatus: "",
            typePublisher: "",
        });
        
        setValue(updatedValue);
        
    }, [values]);

    const handleValues = (key, v) => {
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        searchParams.delete(key);

        const newUrl = `${url.pathname}?${searchParams.toString()}${url.hash}`;
        
        navigate(newUrl, { replace: true });

        setValue(prev => ({
            ...prev,
            [key]: ""
        }));
    };
    return (<>
        {!location.pathname.startsWith("/users/details/") &&
            <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="grid grid-cols-1 sm:grid-cols-4 gap-6 pb-6 overflow-hidden"
                >
                {[ 
                    {
                    title: "New Ads",
                    value: statisticsData[0]?.new_ads?.current_total,
                    percentage: statisticsData[0]?.new_ads?.percentage_change,
                    direction: statisticsData[0]?.new_ads?.direction,
                    subtitle: "Last Month Analytics",
                    icon: <FiberNewIcon className="text-white" fontSize='medium' />,
                    mui: true,
                    iconBg: "bg-green-700"
                    },
                    {
                    title: "No. Active Ads",
                    value: statisticsData[0]?.count_active_ads,
                    subtitle: "Last Month Analytics",
                    icon: <DoneAllIcon className="text-white" fontSize='medium' />,
                    mui: true,
                    iconBg: "bg-green-700"
                    },
                    {
                    title: "No. Ads",
                    value: statisticsData[0]?.count_ads,
                    subtitle: "Last Month Analytics",
                    icon: <FaAdversal className="text-white" size={18} />,
                    iconBg: "bg-green-700"
                    },
                    {
                    title: "Average ad duration",
                    value: statisticsData[0]?.average_duration_ads,
                    subtitle: "Last Month Analytics",
                    icon: <TrendingUpIcon className="text-white" fontSize='medium' />,
                    iconBg: "bg-blue-600",
                    mui: true   
                    },
                ].map((card, idx) => (
                    <motion.div
                    key={idx}
                    initial={{ rotateY: 90, opacity: 0 }}
                    animate={{ rotateY: 0, opacity: 1 }}
                    exit={{ rotateY: 90, opacity: 0 }}
                    transition={{ duration: 0.6, ease: "easeInOut", delay: idx * 0.1 }}
                    className="w-full"
                    style={{ transformStyle: "preserve-3d" }}
                    >
                    <StateCard {...card} />
                    </motion.div>
                ))}
                </motion.div>
            )}
            </AnimatePresence>
        }
        <div className=" bg-thirdly rounded-t-lg px-5 py-3">
            <div className="py-2 flex flex-row justify-between items-center">
                <p className="text-[22px] text-left font-semibold text-white">{currentLang === "en" ? "Filters" : "الفلاتر"}</p>
                {(!location.pathname.startsWith("/users/details/")) && (
                    visible ? <FaArrowUp className="text-gray-300 text-xl cursor-pointer bg-furthly p-1 rounded-sm" onClick={handleVisible} /> : <FaArrowDown className="text-gray-300 text-xl cursor-pointer bg-secondary p-1 rounded-sm" onClick={handleVisible} />
                )}
            </div>
            <div className="flex flex-col py-2 gap-4">
                <div className={`grid ${location.pathname.startsWith("/users/details/")? "grid-cols-2  md:grid-cols-2 sm:grid-cols-1 gap-3" : "grid-cols-1  md:grid-cols-4 sm:grid-cols-2 gap-3"}`}>
                    <div className="w-full">
                        <DropDownFilter options={typeOfAds} value={value.orderStatus} defaultText={t("filters.order_status")} paramkey="orderStatus" />
                    </div>
                    <div className="w-full">
                        <DropDownFilter options={typeOfUsers} value={value.typePublisher} defaultText={t("filters.user_type")} paramkey="typePublisher" />
                    </div>
                    <div className="w-full">
                        <InputFilter  type={"date"} paramkey="from_date"/>
                    </div>
                    <div className="w-full">
                        <InputFilter  type={"date"} paramkey="to_date"/>
                    </div>
                </div>
                <div className={`grid ${location.pathname.startsWith("/users/details/")? "grid-cols-2  md:grid-cols-3 sm:grid-cols-1 gap-3" : "grid-cols-1  md:grid-cols-3 sm:grid-cols-2 gap-3"}`}>
                    <div className="w-full">
                        <DropDownFilterSearch search={searchCategoryParent} options={categoriesParentData} value={value.category_id} defaultText={t("filters.category")} paramkey="category_id" />
                    </div>
                    <div className="w-full">
                        <DropDownFilterSearch search={searchCategoryChild} options={categoriesChildData} value={value.sub_category_id} defaultText={t("filters.sub_category")} paramkey="sub_category_id" />
                    </div>
                    <div className="w-full">
                        <InputFilter placeholder={t("filters.id")}  type={"number"} paramkey="id"/>
                    </div>
                </div>
                <div className={`grid ${location.pathname.startsWith("/users/details/")? "grid-cols-2  md:grid-cols-3 sm:grid-cols-1 gap-3" : "grid-cols-1  md:grid-cols-3 sm:grid-cols-2 gap-3"}`}>
                    <div className="w-full">
                        <InputFilter placeholder={t("filters.min_price")} icon={<MdPriceCheck className="text-white" />} type={"number"} paramkey="minPrice"/>
                    </div>
                    <div className="w-full">
                        <InputFilter placeholder={t("filters.max_price")} icon={<MdPriceCheck className="text-white" />} type={"number"} paramkey="maxPrice"/>
                    </div>
                    <div className="w-full">
                        <DropDownFilter options={typeOfcurrency} value={value.currency} defaultText={t("filters.currency")} paramkey="currency" />
                    </div>
                </div>
                <div className="flex flex-row flex-wrap justify-end items-center gap-5">
                    {Object.entries(value).map(([key, v]) => ( 
                        v != "" && <div className="bg-gray-600 text-white flex justify-between items-center gap-3 rounded-lg text-md px-3 py-[2px]"><button onClick={() => handleValues(key, v)} className="bg-red-500 w-4 h-4 rounded-full text-sm text-white text-bold flex justify-center items-center">X</button> {key}: {String(v)} </div>
                    ))}
                </div>
            </div>
        </div>
    </>)
}